export default __webpack_public_path__ + "static/media/arrow-right.0ec59ecb.svg";